import {
  TEMPLATE_ERROR,
  TEMPLATE_LOADING,
  SET_TEMPLATES,
  SELECT_TEMPLATE,
  GET_EDITOR_INFORMATION_ERROR,
  GET_EDITOR_INFORMATION_LOADING,
  GET_EDITOR_INFORMATION,
  GET_TEMPLATE_HISTORY,
  GET_TEMPLATE_HISTORY_ERROR,
  GET_TEMPLATE_HISTORY_LOADING,
  EDITOR_DATABASE_UPDATE,
  EDITOR_DATABASE_UPDATE_ERROR,
  GET_CURRENT_TEMPLATE_FOR_APPROVAL_LOADING,
  GET_CURRENT_TEMPLATE_FOR_APPROVAL_INFO,
  GET_CURRENT_TEMPLATE_FOR_APPROVAL_ERROR,
  GET_DRAFT_TEMPLATE_FOR_APPROVAL_INFO,
  GET_DRAFT_TEMPLATE_FOR_APPROVAL_LOADING,
  GET_DRAFT_TEMPLATE_FOR_APPROVAL_ERROR,
  APPROVAL_DRAFT,
  APPROVAL_DRAFT_ERROR,
  GET_COMMENTS_APPROVAL_INFO,
  GET_COMMENTS_APPROVAL_LOADING,
  GET_COMMENTS_APPROVAL_ERROR,
  SET_SELECTED_OPTIONS,
  SET_ON_DEMAND_TEMPLATES,
} from "../constants";

const initial_state = {
  loading: {
    templates: false,
  },
  errors: {
    // templates: "Error message"
  },

  // Users
  list: [], // List of available templates
  selected: {}, // Selected template
  approvalPayload: {}, // approval payload
  listEditor: {}, //Editor template data
  approvalCurrent: {}, //approval current data
  listHistory: [], //list for history
  approvalDraft: {}, //approval draft data
  commentList: [], //comments for editor
  deleteList: [], //responses for delete
  selectedOptions: {
    type: "",
    subType: "",
    companyCode: "",
  },
};

export default function (state = initial_state, { type, payload }) {
  const loading = state.loading;

  switch (type) {
    case TEMPLATE_ERROR:
      return {
        ...state,
        errors: payload || { unknown: "Unknown error" },
      };

    case GET_EDITOR_INFORMATION_ERROR:
      return {
        ...state,
        errors: payload || { unknown: "Unknown error" },
      };

    case GET_TEMPLATE_HISTORY_ERROR:
      return {
        ...state,
        errors: payload || { unknown: "Unknown error" },
      };

    case EDITOR_DATABASE_UPDATE_ERROR:
      return {
        ...state,
        errors: payload || { unknown: "Unknown error" },
      };

    case GET_CURRENT_TEMPLATE_FOR_APPROVAL_ERROR:
      return {
        ...state,
        errors: payload || { unknown: "Unknown error" },
      };

    case GET_DRAFT_TEMPLATE_FOR_APPROVAL_ERROR:
      return {
        ...state,
        errors: payload || { unknown: "Unknown error" },
      };

    case APPROVAL_DRAFT_ERROR:
      return {
        ...state,
        errors: payload || { unknown: "Unknown error" },
      };

    case GET_COMMENTS_APPROVAL_ERROR:
      return {
        ...state,
        errors: payload || { unknown: "Unknown error" },
      };

    case TEMPLATE_LOADING:
      loading[payload] = true;
      return {
        ...state,
        loading,
      };

    case GET_CURRENT_TEMPLATE_FOR_APPROVAL_LOADING:
      loading[payload] = true;
      return {
        ...state,
        loading,
      };
    case GET_EDITOR_INFORMATION_LOADING:
      loading[payload] = true;
      return {
        ...state,
        loading,
      };

    case GET_TEMPLATE_HISTORY_LOADING:
      loading[payload] = true;
      return {
        ...state,
        loading,
      };
    case GET_DRAFT_TEMPLATE_FOR_APPROVAL_LOADING:
      loading[payload] = true;
      return {
        ...state,
        loading,
      };

    case GET_COMMENTS_APPROVAL_LOADING:
      loading[payload] = true;
      return {
        ...state,
        loading,
      };

    case SET_TEMPLATES:
      loading.templates = false;

      return {
        ...state,
        loading,
        list: payload,
      };

    case GET_EDITOR_INFORMATION:
      loading.editorData = false;

      return {
        ...state,
        loading,
        listEditor: payload,
      };

    case GET_COMMENTS_APPROVAL_INFO:
      loading.approval = false;

      return {
        ...state,
        loading,
        commentList: payload,
      };

    case GET_CURRENT_TEMPLATE_FOR_APPROVAL_INFO:
      loading.editorData = false;

      return {
        ...state,
        loading,
        approvalCurrent: payload,
      };

    case GET_DRAFT_TEMPLATE_FOR_APPROVAL_INFO:
      loading.editorData = false;

      return {
        ...state,
        loading,
        approvalDraft: payload,
      };

    case GET_TEMPLATE_HISTORY:
      loading.templates = false;

      return {
        ...state,
        loading,
        listHistory: payload,
      };

    case SELECT_TEMPLATE:
      return {
        ...state,
        selected: payload,
      };

    case EDITOR_DATABASE_UPDATE:
      return {
        ...state,
        selected: payload,
      };

    case APPROVAL_DRAFT:
      return {
        ...state,
        approvalPayload: payload,
      };

    case SET_SELECTED_OPTIONS:
      return {
        ...state,
        selectedOptions: payload,
      };

    case SET_ON_DEMAND_TEMPLATES:
      loading.templates = false;
      return {
        ...state,
        loading,
        list: payload,
      };

    default:
      return state;
  }
}
